"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleGlass = exports.changeGlassColor = undefined;

var _defaults = require("../defaults");

var defs = _interopRequireWildcard(_defaults);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var changeGlassColor = exports.changeGlassColor = "\n@keyframes changeGlassColor {\n  0% {\n    border-bottom-color: " + defs.hourglassActiveColor + ";\n    border-top-color: " + defs.hourglassDefaultColor + ";\n  }\n\n  50% {\n    border-bottom-color: " + defs.hourglassDefaultColor + ";\n    border-top-color: " + defs.hourglassActiveColor + ";\n  }\n\n  100% {\n    border-bottom-color: " + defs.hourglassActiveColor + ";\n    border-top-color: " + defs.hourglassDefaultColor + ";\n  }\n}\nanimation-duration: " + defs.hourglassAnimationSpeed + ";\nanimation-iteration-count: infinite;\nanimation-name: changeGlassColor;\nanimation-timing-function: ease-in-out";
var styleGlass = exports.styleGlass = "\n" + changeGlassColor + ";\nborder-left: " + defs.hourglassAngle + " solid transparent;\nborder-right: " + defs.hourglassAngle + " solid transparent;\nwidth: " + defs.hourglassWidth;